"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltipArrow = exports.StyledTooltip = exports.StyledTargetWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../utils/helpers");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  border-style: solid;\n  position: absolute;\n  margin: 0;\n\n  &[data-placement^='top'] {\n    border-width: 5px 5px 0 5px;\n    border-color: ", " transparent\n      transparent transparent;\n    bottom: -5px;\n  }\n  &[data-placement^='bottom'] {\n    border-width: 0 5px 5px 5px;\n    border-color: transparent transparent\n      ", " transparent;\n    top: -5px;\n  }\n  &[data-placement^='right'] {\n    border-width: 5px 5px 5px 0;\n    border-color: transparent ", "\n      transparent transparent;\n    left: -5px;\n  }\n  &[data-placement^='left'] {\n    border-width: 5px 0 5px 5px;\n    border-color: transparent transparent transparent\n      ", ";\n    right: -5px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      opacity: 1;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      opacity: 0;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "\n    ", ";\n  ", ";\n  color: ", ";\n  text-align: center;\n  background: ", ";\n  border-radius: ", ";\n  max-width: 400px;\n  opacity: 0;\n  transition: opacity ", "ms\n    cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n  z-index: 2000;\n\n  &[data-placement^='top'] {\n    margin-bottom: 8px;\n  }\n  &[data-placement^='bottom'] {\n    margin-top: 8px;\n  }\n  &[data-placement^='right'] {\n    margin-left: 8px;\n  }\n  &[data-placement^='left'] {\n    margin-right: 8px;\n  }\n\n  &[data-x-out-of-boundaries] {\n    display: none;\n  }\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTargetWrapper = _styledComponents.default.div(_templateObject());

exports.StyledTargetWrapper = StyledTargetWrapper;

var StyledTooltip = _styledComponents.default.div(_templateObject2(), function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 2, '/');
}, (0, _helpers.fontSize)(-2), function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.palette.transparentBlack;
}, function (props) {
  return props.theme.borderRadius || '3px';
}, function (props) {
  return props.transitionDuration;
}, function (props) {
  return props.transitionState === 'entering' && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.transitionState === 'entered' && (0, _styledComponents.css)(_templateObject4());
});

exports.StyledTooltip = StyledTooltip;

var StyledTooltipArrow = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.theme.palette.transparentBlack;
}, function (props) {
  return props.theme.palette.transparentBlack;
}, function (props) {
  return props.theme.palette.transparentBlack;
}, function (props) {
  return props.theme.palette.transparentBlack;
});

exports.StyledTooltipArrow = StyledTooltipArrow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/Tooltip/Tooltip-styled.js
// module id = 1634
// module chunks = 0